import type { GTimePickerProps } from '~/presentation/ui';

import { GTimePicker } from '~/presentation/ui';
import { useDateTime } from './hooks';

interface SelectDate extends GTimePickerProps {
  disabled?: boolean;
}

export const SelectDate: React.FC<SelectDate> = ({ disabled, ...props }) => {
  const { rangeAddition } = useDateTime();

  return (
    <GTimePicker
      popoverProps={{
        preferredAlignment: 'right',
      }}
      rangeAddition={rangeAddition}
      {...props}
    />
  );
};
